import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';

import { BodyText } from '../codeForm/CodeForm-styled-components';

export const ResendCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResendCodeText = styled(BodyText)`
  color: ${BRAND_COLORS.black};
`;
